import { DebtScheduleItem } from 'ng2-app/models/dscr/DebtScheduleItem.struct';

const typeBase = '[DebtSchedule]';

export class GetDebtSchedules {
  static readonly type = `${typeBase} GetDebtSchedules`;
  constructor(
    public borrowerId: number,
  ) {}
}

export class CreateDebtScheduleItem {
  static readonly type = `${typeBase} CreateDebtScheduleItem`;
  constructor(
    public borrowerId: number,
    public debtScheduleItem: DebtScheduleItem,
  ) {}
}

export class UpdateDebtScheduleItem {
  static readonly type = `${typeBase} UpdateDebtScheduleItem`;
  constructor(
    public borrowerId: number,
    public debtScheduleItem: DebtScheduleItem,
    public id: number | undefined,
  ) {}
}

export class DeleteDebtScheduleItem {
  static readonly type = `${typeBase} DeleteDebtScheduleItem`;
  constructor(
    public id: number,
  ) {}
}
